import elementLocale from 'element-ui/lib/locale/lang/zh-TW'

export default {
  floorplanEvaluation: {
    entry: "建築戶型評價",
    aiResultOnly: "評價使用目前專案最新一次成功的 AI 建築設計結果。前端修改無論是否儲存，均不參與評價。",
    running: "正在評價建築戶型／載入結果",
    previousVersion: "此評價對應較早的 AI 建築設計結果，或暫時無法確認結果版本一致性。",
    total: "綜合得分",
    normalized: "百分制換算分",
    objective: "客觀得分",
    subjective: "主觀得分",
    details: "評價詳情",
    empty: "尚無已完成的評價",
    refresh: "重新整理結果",
    start: "開始評價",
    failed: "建築戶型評價失敗，請重試",
    OBJ_01: "房間類型與數量正確性",
    OBJ_03: "MyBox 經驗尺寸符合度",
    OBJ_06: "相鄰樓層樓梯對齊",
    OBJ_07: "主要房間連續外牆接觸潛力",
    functional_zoning: "功能分區",
    circulation_organization: "交通組織",
    privacy: "私密性",
    spatial_comfort: "空間舒適性"
  },
  common: {
    appName: 'MH House',
    home: '首頁',
    login: '登入',
    workspace: '工作台',
    logout: '登出',
    notFound: '頁面不存在',
    backHome: '返回首頁',
    cancel: '取消',
    confirm: '確認',
    apply: '套用',
    close: '關閉',
    all: '全部',
    user: '使用者',
    updated: '更新',
    project: '專案'
  },
  nav: {
    wallet: '錢包',
    changePassword: '修改密碼',
    titles: {
      projectsStructure: '結構專案',
      houseDesign: '專案詳情',
      architecturePlan: '建築平面設計',
      structureDesign: '結構設計',
      structureCalculation: '結構計算',
      designReport: '設計結果報告'
    }
  },
  home: {
    title: 'MH House WebUI',
    subtitle: '一個為新專案準備的乾淨前端骨架。',
    openWorkspace: '進入工作台'
  },
  login: {
    title: '登入',
    username: '使用者名稱',
    password: '密碼',
    submit: '登入',
    placeholder: '登入介面占位，後端協議確定後替換。'
  },
  workspace: {
    title: '工作台',
    subtitle: '受保護路由占位頁面。'
  },
  projects: {
    searchPlaceholder: '請輸入專案標題',
    empty: '暫無專案',
    fetchFailed: '取得專案列表失敗',
    missingIdempotencyKey: '專案缺少冪等鍵，無法進入詳情',
    projectFallback: '專案 {id}',
    newProject: '新建專案',
    createDialogTitle: '新建專案',
    createDialogPlaceholder: '請輸入專案名稱',
    createNameRequired: '請輸入專案名稱',
    createFailed: '建立專案失敗',
    createConfirm: '建立',
    manageProjects: '管理專案',
    exitManage: '退出管理',
    deleteSelected: '刪除（{count}）',
    deleteConfirmTitle: '刪除專案',
    deleteConfirmMessage: '確定刪除選取的 {count} 個專案嗎？此操作無法復原。',
    deleteConfirmButton: '刪除',
    deleteSuccess: '已刪除 {count} 個專案',
    deleteFailed: '刪除專案失敗'
  },
  houseDesign: {
    backToProjects: '返回專案',
    pageTitle: '專案詳情',
    pageTitleWithKey: '專案詳情 - {key}',
    idempotencyKey: '專案冪等鍵：{key}',
    missingKey: '缺少專案冪等鍵，請從專案列表重新進入。',
    progressTitle: '專案流程進展',
    enterStepTitle: '進入步驟',
    enterStep: '進入{step}',
    stepStatus: {
      completed: '已完成',
      current: '目前步驟',
      pending: '待進入'
    },
    steps: {
      architecturePlan: '建築平面設計',
      structureDesign: '結構設計',
      structureCalculation: '結構計算',
      designReport: '設計結果報告'
    }
  },
  constraints: {
    back: '返回專案',
    title: '請告訴我們建築的預算與間口',
    budget: {
      title: '預算'
    },
    frontage: {
      title: '間口',
      meters: '約 {meters} m'
    },
    recommendFailed: '暫時無法取得商品推薦，請稍後重試',
    next: '下一步'
  },
  structureDesign: {
    generating: '生成中...',
    back: '返回',
    title: '一戶建AI設計',
    subtitle: '設計編輯器 · {name}',
    undo: '復原',
    redo: '重做',
    save: '儲存',
    saveToStorage: '儲存',
    exportToFile: '匯出到檔案',
    exportProjectJson: '匯出專案 JSON',
    exportCadJson: '匯出 CAD JSON',
    cadExport: {
      warningTitle: 'CAD 交付驗證警告',
      warningMessage: 'CAD JSON 含有驗證警告，仍可下載，但交付資料尚未完全驗證。',
      continue: '仍然匯出',
      fatal: '平面圖含有無效 CAD 幾何，無法匯出。',
      failed: 'CAD JSON 匯出失敗，請再試一次。',
      exported: 'CAD JSON 已匯出：{fileName}',
      annotationsSaveFailed: '尺寸標註已包含在匯出檔案中，但無法儲存到目前專案。',
      issueCategories: {
        geometry: '幾何驗證警告（{code}）',
        annotations: '標註驗證警告（{code}）',
        structure: 'AI 結構驗證警告（{code}）'
      }
    },
    load: '載入',
    project: '專案',
    tools: '工具',
    select: '選擇',
    sampleRoom: '範例房間',
    catalog: '目錄',
    searchCatalog: '搜尋目錄',
    designAssetRoomFilter: '房間',
    designAssetStyleFilter: '風格',
    designAssetRooms: {
      kitchen: '廚房',
      bathroom: '浴室',
      washroom: '洗面室',
      outdoor: '戶外',
      'living-dining': '客廳餐廳',
      'master-bedroom': '主臥',
      'kids-room': '兒童房'
    },
    designAssetStyles: {
      'white-model': '白模',
      natural: '自然',
      'simple-modern': '簡約現代',
      japandi: '日式北歐',
      vintage: '復古'
    },
    catalogFilterEmpty: '找不到符合的素材',
    catalogFilterClear: '清除篩選',
    catalogFilterLoading: '正在篩選…',
    catalogFilterBack: '返回分類瀏覽',
    catalogFilterToggle: '展開或收起篩選',
    properties: '屬性',
    settings: '設定',
    projectConfiguration: '專案設定',
    aiDesign: 'AI 設計參數',
    generate: '產生設計',
    view2d: '2D 檢視',
    view3d: '3D 檢視',
    switchTo3d: '點擊將主畫面切換為 3D',
    switchTo2d: '點擊將主畫面切換為 2D',
    zoomIn: '放大',
    zoomOut: '縮小',
    fitView: '適應畫布',
    openCatalog: '開啟目錄',
    export: '匯出',
    exportChooseFormat: '選擇匯出格式',
    import: '匯入',
    developing: '開發中',
    catalogTitle: '元素目錄',
    catalogHint: '選擇一個元素，然後在二維畫布中點擊完成放置',
    catalogAvailable: '共 {count} 個可用元素',
    catalogEmptyTitle: '沒有找到符合的元素',
    catalogEmptyHint: '嘗試更換分類或搜尋關鍵字',
    catalogFooter: '目錄 / {category}',
    clearSearch: '清除搜尋',
    inspectorDeveloping: '此部分功能開發中',
    selectionSummary: '已選擇 {count} 個元素',
    emptyState: '選擇一個元素或從目錄選擇構件，然後在畫布上編輯。',
    editorToolbar: {
      label: '編輯器命令',
      file: '檔案',
      clear: '清空',
      ai: 'AI',
      pdf: 'PDF 匯出',
      html: 'HTML 匯出',
      share: '分享',
      clearConfirmTitle: '清空方案',
      clearConfirmMessage: '此操作將清空目前方案內容，是否繼續？',
      placeholderNotice: '此功能將在後續模組接入，目前為占位入口。'
    },
    clearScene: {
      success: '方案已清空',
      failed: '清空方案失敗，請重試'
    },
    drawingUnderlay: {
      title: '底圖',
      show: '顯示底圖',
      hide: '隱藏底圖',
      opacity: '底圖透明度',
      elementOpacity: '構件透明度'
    },
    viewSettings: {
      title: '3D 顯示設定',
      daylight: '日照',
      daylightSlider: '日照時間',
      presets: {
        morning: '早晨',
        midday: '中午',
        evening: '傍晚',
        night: '夜晚'
      },
      ceilingHeight: '天花板高度',
      sectionCut: '剖切',
      sectionCutHint: '不顯示剖切高度以上的部分。'
    },
    editorToolGroups: {
      draw: '畫房間/牆體',
      openings: '放門窗',
      structure: '加結構',
      furnishings: '家具軟裝'
    },
    editorToolPanels: {
      drawHouse: '戶型',
      layout: '家具與材質'
    },
    camera: {
      tool: "相機",
      renderTool: "渲染",
      renderTitle: "渲染",
      renderRecaptureHint: "依相機目前的位置重新截圖",
      previewTitle: "相機 {index} · 3D 檢視",
      openComposition: "調整構圖",
      previewHint: "點擊調整構圖",
      placingHint: "請在平面圖上點擊以放置相機",
      addOverhead: "3D 俯視",
      addOverheadHint: "新增從上方俯視建築的相機",
      overheadBadge: "俯視",
      overheadHint: "從上方俯視所選樓層的相機。",
      compositionFromPreview: "構圖在右上角的 3D 檢視中調整。",
      place: "放置相機",
      panelTitle: "相機",
      empty: "沒有相機。請在平面圖上放置",
      limitReached: "最多 {max} 台相機",
      item: "相機 {index}",
      position: "位置",
      elevation: "高度",
      yaw: "朝向",
      pitch: "俯仰",
      fov: "視野",
      remove: "刪除相機",
      enterComposition: "進入 3D 構圖",
      clampedTo: "已限制到 {value}",
      readonlyHint: "專案為唯讀，相機不可編輯",
      lockedWhileRendering: "出圖進行中，相機不可編輯",
      compositionTitle: "3D 構圖 · 相機 {index}",
      compositionDone: "完成",
      compositionCancel: "取消",
      compositionHint: "拖曳旋轉視角、滾輪縮放；框內即最終出圖範圍",
      compositionAspect: "16:9（與出圖比例一致）",
      compositionDegraded: "視窗太小，構圖框已按比例縮放顯示",
      batchEntry: "批次出圖",
      batchViewResults: "查看出圖結果",
      batchFromCameras: "使用 {count} 台相機出圖",
      batchTitle: "批次出圖",
      batchNew: "新增出圖",
      batchHistoryEmpty: "尚無出圖記錄，請於右側相機面板發起出圖",
      batchFailedUnknown: "生成失敗，未回傳具體原因，請重試或稍後再試",
      batchFailedTimeout: "生成逾時，請重試",
      batchCaptureBusy: "上一次截圖尚未結束，請稍候再試",
      batchPreviousResult: "上一輪結果",
      batchCameraNoResult: "尚無出圖結果",
      batchCameraRemoved: "相機已刪除，出圖結果保留",
      batchRowSatisfied: "已滿足，本輪未生成",
      batchStepConfig: "設定",
      batchStepCapture: "確認截圖",
      batchCaptureConfirm: "請確認各相機取景，如需調整可重新截圖",
      batchCaptureZoom: "點擊查看大圖",
      batchRecapture: "重新截圖",
      batchCaptureNext: "使用 {count} 張，繼續設定",
      batchCaptureAllFailed: "截圖全部失敗，請調整相機位置後重試",
      batchStepRender: "算圖",
      batchTarget: "每台目標張數",
      batchStyle: "風格",
      batchStylized: "畫風",
      batchResolution: "解析度",
      batchPromptPlaceholder: "補充要求（選填）",
      batchStartFailed: "出圖啟動失敗，請稍後重試",
      batchGenerate: "生成缺口 {count} 張",
      batchAllSatisfied: "全部機位已滿足，無需生成",
      batchNoCameras: "請先在平面圖上放置相機",
      batchAdopt: "採用",
      batchAdopted: "已採用 {n}/{k}",
      batchSatisfied: "已滿足 {k}/{k}",
      batchStale: "相機 {index} 的機位已變更，先前採用的 {n} 張圖不再計入",
      batchCapturing: "正在截圖 {i}/{n}",
      batchSubmitting: "正在提交 {i}/{n}，請勿離開頁面",
      batchQueued: "排隊中",
      batchPendingCapture: "待截圖",
      batchCaptured: "已截圖，待提交",
      batchRunning: "生成中",
      batchDone: "已完成",
      batchFailed: "失敗",
      batchRetry: "重試",
      batchSkip: "跳過",
      batchUnsupported: "後端暫不支援一次生成 {n} 張，請先升級 api 服務後再試",
      batchInvalid: "已失效",
      batchClose: "關閉",
    },
    editorToolSections: {
      stair: '樓梯',
      accessory: '小物件',
      material: '材質',
      furniture: '家具',
      lighting: '照明',
      builtin: '木作',
      appliance: '家電',
      equipment: '設備'
    },
    editorToolCategories: {
      stairStairs: '樓梯',
      accessoryClocks: '時鐘',
      accessoryMirrors: '鏡子',
      accessoryCushions: '抱枕',
      accessoryArt: '裝飾畫・牆飾',
      accessoryPlants: '綠植',
      accessoryOther: '其他',
      furnitureDiningTables: '餐桌',
      furnitureDesks: '書桌',
      furnitureDoubleBeds: '雙人床',
      furnitureSingleBeds: '單人床',
      furnitureRugs: '地毯',
      furnitureOther: '其他',
      lightingPendant: '吊燈',
      lightingDown: '筒燈',
      lightingSpot: '投射燈',
      lightingStand: '立燈・檯燈',
      lightingBracket: '壁燈',
      lightingOther: '其他',
      builtinCounter: '檯面',
      builtinShelf: '層架',
      builtinPillowShelf: '床頭層板',
      builtinStorage: '收納',
      builtinEntranceStorage: '玄關收納',
      builtinOther: '其他',
      applianceRefrigerator: '冰箱',
      applianceTv: '電視',
      applianceWasher: '洗衣機',
      applianceDryer: '烘乾機',
      applianceMicrowave: '微波爐',
      applianceVacuum: '吸塵器',
      applianceOther: '其他',
      equipmentKitchen: '廚房',
      equipmentCupboard: '櫥櫃',
      equipmentToilet: '馬桶',
      equipmentWashbasin: '洗手台',
      equipmentBathtub: '浴缸',
      equipmentWasher: '洗衣機',
      equipmentWaterHeater: '熱水器',
      equipmentAirConditioner: '空調',
      equipmentSwitch: '開關',
      equipmentOther: '其他',
      furnitureKitchen: '廚房',
      furnitureToilet: '廁所',
      furnitureBathroom: '浴室',
      furnitureWashbasins: '洗面台',
      furnitureAppliances: '家電',
      furnitureAirConditioning: '空調設備',
      furnitureWaterHeating: '熱水設備',
      walls: '牆體',
      doorWindow: '門窗',
      holes: '洞口',
      structure: '結構',
      stairs: '樓梯',
      furniture: '家具',
      kitchenBath: '廚衛',
      furnitureSofa: '沙發',
      furnitureTables: '桌/書桌',
      furnitureChairs: '椅/凳',
      furnitureTableSets: '桌椅組合',
      furnitureBeds: '床',
      furnitureCabinets: '收納',
      furnitureStorage: '收納',
      furnitureLighting: '照明',
      furnitureCushions: '抱枕',
      furnitureClocks: '時鐘',
      furnitureArtDecor: '藝術裝飾',
      furnitureMirrors: '鏡子',
      materialWallpaper: '牆材',
      materialFlooring: '地板',
      other: '其他',
      kitchenBathCabinet: '櫥櫃',
      kitchenBathKitchen: '廚房',
      kitchenBathEquipment: '設備',
      kitchenBathVanity: '浴室櫃',
      kitchenBathSanitary: '衛浴'
    },
    editorToolRequired: {
      wall: '牆體',
      area: '房間區域',
      door: '門',
      doorDouble: '雙開門',
      slidingDoor: '推拉門',
      window: '窗',
      sashWindow: '推拉窗',
      gate: '大門',
      floorOpening: '樓板洞口',
      column: '柱子',
      columnSquare: '方柱',
      beam: '梁',
      simpleStair: '簡易樓梯',
      sofa: '沙發',
      tables: '桌/茶几',
      chairs: '凳/椅',
      tableSets: '桌椅組合',
      beds: '床/組合床',
      cabinets: '櫃/架',
      kitchenCabinet: '櫥櫃',
      kitchen: '廚房',
      equipment: '設備',
      bathroomVanity: '浴室櫃',
      sanitary: '衛浴'
    },
    editorToolUnavailable: '暫未提供',
    editorProperty: {
      emptyTitle: '未選中物件',
      emptyHint: '選擇牆、門窗、家具等後可在此編輯。'
    },
    wallSurfaceMaterial: {
      title: '牆面材質',
      currentSide: '牆面材質 · {side}',
      sideA: 'A · 沿牆方向左側',
      sideB: 'B · 沿牆方向右側',
      heading: '牆面材質',
      sideAShort: 'A面',
      sideBShort: 'B面',
      sideGroup: '牆面側別',
      texture: '紋理',
      color: '顏色',
      source: '來源',
      clearSide: '清除本側覆蓋',
      sources: { surface: '本側覆蓋', legacy: '牆體屬性', theme: '主題預設值' },
      textures: { bricks: '磚牆', painted: '塗料牆' }
    },
    property: {
      clampedTo: '數值已調整至範圍 {min}-{max}，實際應用值為 {actual}',
      fittedToWall: '為符合牆體，已調整為 {actual}'
    },
    editorBottom: {
      otherFloorOpacity: '其他樓層透明度',
      showOtherFloors: '顯示其他樓層',
      hideOtherFloors: '隱藏其他樓層',
      expand3d: '放大',
      previewInCanvas: '3D 預覽已移至中央畫布',
      statistics: '資料統計'
    },
    aiRoomDesign: {
      title: 'AI 房間設計',
      open: 'AI 房間',
      selectedProduct: '已選商品',
      noProduct: '尚未選擇商品',
      selectProduct: '選擇商品',
      browseProducts: '瀏覽商品',
      layerCount: '層數',
      livingRoom: '起居室',
      diningRoom: '餐廳',
      masterRoom: '主臥',
      secondRoom: '次臥/書房',
      kitchen: '廚房',
      bathroom: '衛生間',
      storage: '儲藏室',
      staircase: '樓梯',
      notice1: 'AI 將參考此需求，最終房間構成由算法決定',
      notice2: '生成的佈局將對齊 455mm 模塊網格，並會移除現有門窗',
      elapsed: '已耗時',
      submit: '生成房間佈局',
      needAtLeastOneRoom: '至少需要一個房間',
      successTitle: '房間佈局生成成功'
    },
    aiWindowDesign: {
      title: 'AI 門窗設計',
      open: 'AI 門窗',
      roomCount: '當前房間數',
      notice: '將為所有牆體生成門窗，現有門窗將被替換',
      elapsed: '已耗時',
      submit: '生成門窗',
      successTitle: '門窗生成成功',
      successMessage: '已生成 {doorCount} 個門、{windowCount} 個窗'
    },
    aiCandidatePreview: {
      previewTitle: 'AI 方案預覽',
      currentScene: '當前方案',
      candidateScene: 'AI 候選方案',
      previewHint: '請對比兩個方案，確認後應用',
      floorLabel: '樓層',
      outlineDiffsTitle: '輪廓差異明細',
      layer: '樓層',
      beforeSize: '原尺寸',
      afterSize: 'AI 尺寸',
      sizeChange: '尺寸變化',
      areaCoverage: '覆蓋面積',
      areaChange: '面積變化',
      applyRoomLabel: '應用 AI 房間設計',
      applyWindowLabel: '應用 AI 門窗設計'
    },
    reportCapture: {
      title: '報告圖片確認',
      stepFloors: '2D 戶型',
      stepViews: '3D 視角',
      floorsHint: '請確認各樓層的戶型圖，系統已依內容自動截圖。',
      viewsHint: '請確認 3D 視角圖片，目前視角將作為主圖。',
      noFloors: '沒有可用的樓層。',
      noContent: '該樓層沒有可顯示的內容。',
      viewIdle: '尚未截圖。',
      recapture: '重新截圖',
      capture: '截圖',
      reframe: '框選範圍',
      reframeCancel: '結束框選',
      reframeHint: '在預覽圖上拖曳以選擇截圖範圍。',
      zoomIn: '放大',
      zoomOut: '縮小',
      confirm: '確認',
      delete: '刪除',
      next: '下一步：3D 視角',
      done: '完成',
      cancel: '取消',
      confirmIncomplete: '請先確認所有樓層平面圖和 5 張 3D 報告圖片後再完成。',
      mainBadge: '主圖',
      captureFailed: '截圖取得失敗。',
      statusIdle: '未截圖',
      statusCapturing: '截圖中...',
      statusReady: '待確認',
      statusConfirmed: '已確認',
      statusError: '錯誤',
      summary: '已確認：樓層 {floors}/{floorTotal} · 3D {views} 張',
      storageTrimmed: '為控制本機儲存容量，已裁剪 {count} 張多餘的 3D 視角圖片。',
      viewNames: {
        main: '主視角',
        current: '目前視角',
        front: '正面',
        back: '背面',
        left: '左側',
        right: '右側'
      }
    },
    reportAssetsMissing: {
      title: '報告圖片尚未確認',
      message: '目前專案尚未確認平面圖和 3D 報告圖片。你可以先確認圖片，也可以使用系統預設產生的報告資產繼續匯出。',
      confirmImages: '前往確認圖片',
      useDefault: '繼續使用預設資產匯出',
      cancel: '取消'
    },
    reportAssetDefault: {
      generateFailed: '預設報告資產產生失敗，請稍後再試。',
      retry: '重試',
      missingFloorPlan: '缺少樓層平面圖',
      missing3dView: '缺少 3D 報告圖片',
      captureFailed: '截圖取得失敗'
    },
    shareLink: {
      title: '分享連結',
      generating: '正在產生分享連結...',
      mockNotice: '此連結為示範連結，正式分享將在後端介面接入後啟用。',
      copy: '複製連結',
      copied: '已複製',
      copyFailed: '複製失敗，請手動複製',
      error: '分享連結產生失敗',
      retry: '重試',
      close: '關閉'
    },
    roomAreas: {
      dirtyHint: '房間區域可能已變化，請點擊「重新識別房間區域」更新面積。',
      recompute: '重新識別房間區域',
      recomputeSuccess: '房間區域已重新識別',
      recomputeFailed: '房間區域識別失敗，已保留原區域',
      recomputeHistory: '重新識別房間區域',
      metricsSummary: '共 {roomCount} 個房間 · 總面積 {totalAreaM2} m² · 臥室 {bedroomCount}'
    },
    exportPdf: {
      success: 'PDF 已開始下載',
      failed: 'PDF 匯出失敗',
      mockNotice: '目前為 mock 樣例 PDF，正式報告將在二階段後端排版後提供。',
      capturePartial: '部分截圖採集失敗，已繼續匯出（不影響編輯）。'
    },
    exportHtml: {
      success: 'HTML 報告已匯出並在新分頁預覽',
      failed: 'HTML 匯出失敗',
      mockNotice: '目前為靜態 mock HTML，正式託管發布將在二階段提供。',
      capturePartial: '部分截圖採集失敗，已繼續匯出（不影響編輯）。'
    },
    deleteSelected: '刪除選取',
    applyToSelection: '套用到選取項目',
    moveSelected: '移動選取項目',
    moveToFloor: '移動到樓層',
    visible: '可見',
    unchanged: '不變',
    warnings: '警告',
    errors: '錯誤',
    aiSubmitting: '正在提交 AI 任務...',
    aiProcessing: 'AI 正在產生 · {seconds} 秒 · 第 {attempt} 次查詢',
    aiTodo: 'TODO：AI 服務介面暫不啟用，參數已儲存。',
    featureDeveloping: '功能開發中',
    savedLocally: '已儲存。',
    saveFailed: '目前修改尚未儲存。',
    draftRestored: '已恢復未儲存的編輯草稿。',
    versionRestored: '已恢復本機版本。',
    projectLoaded: '專案已載入。',
    invalidProjectJson: '專案 JSON 無效。',
    importDialogTitle: '匯入本機 JSON',
    importAsNewHint: '將匯入為新建專案，不影響目前專案。',
    importStructureDecodeFailed: '結構資料無法解析，僅匯入建築部分。',
    importName: '專案名稱',
    importBudget: '預算（萬日圓）',
    importFrontage: '間口（間）',
    importConfirm: '匯入為新專案',
    importRequiredFields: '請填寫專案名稱、預算與間口後再匯入。',
    importedAsNewProject: '已作為新專案匯入。',
    groups: '群組',
    floors: '樓層',
    opacity: '透明度',
    currentFloor: '目前樓層',
    floorProperties: '樓層屬性',
    basicParams: '基礎參數',
    layoutOpacity: '顯示參數',
    deleteFloor: '刪除樓層',
    deleteCurrentFloor: '刪除目前樓層',
    deleteFloorConfirmMessage: '刪除樓層會將樓層內的所有設計內容都刪除，是否繼續？',
    guides: '輔助線',
    newGroup: '新建群組',
    addSelected: '加入選取',
    groupName: '群組名稱',
    rotate: '旋轉',
    duplicate: '複製',
    ungroup: '取消群組',
    deleteAll: '全部刪除',
    removeFromGroup: '從群組移除',
    addFloor: '新增樓層',
    addUpperFloor: '新建上層',
    addLowerFloor: '新建下層',
    deleteFloorButton: '刪除當前樓層',
    floorInsertPosition: '生成位置',
    floorPositionAbove: '上層（目前樓層之上）',
    floorPositionBelow: '下層（目前樓層之下）',
    floorName: '樓層名稱',
    copyStructure: '複製目前樓層戶型結構',
    confirm: '確認',
    duplicateFloor: '複製樓層',
    selectAllFloor: '全選',
    selectAllFloorElements: '全選樓層元素',
    lock: '鎖定',
    altitude: '高度',
    floorHeight: '層高',
    slabThickness: '樓板厚度',
    moveUp: '上移',
    moveDown: '下移',
    addSelectedElement: '加入選取元素',
    noVersions: '暫無手動儲存版本。',
    restore: '恢復',
    localVersions: '本機版本',
    sceneWidth: '場景寬度 ({unit})',
    sceneHeight: '場景高度 ({unit})',
    name: '名稱',
    description: '描述',
    unit: '單位',
    familySize: '家庭人數',
    style: '風格',
    budget: '預算',
    daylightPriority: '優先採光',
    notes: '備註',
    roomRequirements: '房間需求',
    roomRelationships: '房間關係',
    fromRoom: '起始房間',
    toRoom: '目標房間',
    add: '新增',
    aiServiceTodo: 'TODO: AI 服務',
    rooms: {
      living_room: '客廳',
      bedroom: '臥室',
      kitchen: '廚房',
      bathroom: '衛浴',
      dining_room: '餐廳'
    },
    styles: {
      modern: '現代',
      minimal: '極簡',
      classic: '經典',
      industrial: '工業'
    },
    budgets: {
      economy: '經濟',
      standard: '標準',
      premium: '高端'
    },
    roomStatistics: {
      title: '房間資料統計',
      scope: '範圍',
      allFloors: '全部樓層',
      unnamedOrUnrecognized: '未命名/未識別',
      roomType: '房間類型',
      roomCount: '數量',
      totalRooms: '總房間數',
      totalArea: '總面積',
      calculating: '正在計算',
      refreshing: '正在更新',
      stale: '資料可能不是最新',
      recompute: '重新計算房間面積',
       noData: '無可用統計資料'
     },
     aiStructure: {
       entry: 'AI 結構生成',
       modes: {
         label: '顯示模式',
         architecture: '建築',
         structure: '結構'
       },
       overlay: {
         showBuilding: '顯示建築底圖',
         hideBuilding: '隱藏建築底圖',
         opacity: '建築底圖透明度'
       },
       plans: {
         label: '結構平面圖',
         foundation: '一樓樓板結構圖',
         'beam-column': '{floor} 屋架結構圖',
         'bearing-wall': '{floor} 耐力牆配置圖'
       },
       lineModes: {
         label: '繪製模式',
         line: '線',
         fixedWidth: '固定寬度線',
         cappedLine: '端部線'
       },
       messages: {
         readOnly: '目前顯示模式為唯讀。',
         applied: '結構方案已套用。'
       },
       errors: {
         system: '無法取得結構資料，請重試。',
         unavailable: '結構資料無法使用，請重新生成。',
         readOnly: '目前顯示模式為唯讀。'
       },
       properties: {
         title: '結構物件屬性',
         empty: '選擇結構物件後，這裡顯示唯讀屬性。',
         layer: '樓層',
         type: '類型',
         role: '角色',
         section: '斷面',
         elevation: '標高',
         hostWall: '宿主牆',
         wallSpecification: '牆規格'
       }
     },
     mechanicsCheck: {
       historyUnlinked: "歷史校驗未記錄結構關聯，無法確認適用版本。請重新執行力學校驗。",
       runningPrevious: "新一輪校驗中，目前顯示上次成功完成的結果。",
       latestFailedPrevious: "最新一次校驗失敗，目前顯示上次成功完成的結果。",
       recoveryFailed: "雲端校驗結果載入失敗，請重新整理重試。",
       recoveryUnlinked: "此結構缺少可驗證的任務關聯，請重新生成結構後執行校驗。",
       showFailures: '查看不合格構件',
       hideFailures: '取消查看',
       detailTitle: '構件不合格詳情',
       detailEmpty: '校驗結果未提供詳細說明。',
       entry: '結構力學校驗',
       requiresStructure: '請先完成 AI 結構生成。',
       started: '結構力學校驗已開始。',
       completed: '結構力學校驗已完成。',
       failed: '結構力學校驗失敗，請重試。',
       resultTitle: '力學校驗結果',
       resultLoading: '正在進行結構力學校驗…',
       resultPreparing: '正在讀取力學校驗結果…',
       resultPreparingDescription: '校驗計算已完成，正在讀取結果檔案。',
       resultEmpty: '尚未執行結構力學校驗。',
       statusDescription: '正在等待校驗結果，目前結構仍在顯示。'
     }
   },
  designEvaluation: {
    entry: '設計評價',
    dialogTitle: '設計評價',
    planPreviewLabel: '平面圖',
    previewLoading: '正在產生平面圖',
    previewFailed: '該樓層平面圖產生失敗',
    retryPreview: '重試',
    designNotReady: '請先完成 AI 設計',
    backendUnavailable: '評價功能暫不可用',
    scoreLabel: '評分',
    scoreRequired: '請選擇 1–10 分',
    scoreAriaHint: '評分 1 至 10',
    commentLabel: '評價意見',
    commentPlaceholder: '請輸入評價',
    commentCounter: '已輸入 {count} / 1000',
    submissionNotice: '平面圖僅供確認；提交內容僅包含設計ID、評分和評語',
    submit: '提交評價',
    cancel: '取消',
    submitting: '提交中',
    successMsg: '評價已記錄',
    errorScore: '評分無效，請選擇 1–10 整數',
    errorCommentTooLong: '評價文字超過 1000 字元',
    errorForbidden: '目前帳號無評價權限',
    errorNotFound: '設計不存在或不可存取',
    errorNotReady: 'AI 設計尚未完成',
    errorRateLimited: '提交過於頻繁，請稍後重試',
    errorInternal: '提交失敗，請稍後重試',
    errorGeneric: '提交失敗'
  },
  floorplan: {
    categories: {
      lines: '牆體',
      holes: '門窗',
      structure: '結構',
      furnishings: '家具軟裝',
      items: '物件',
      areas: '區域'
    },
    elements: {
      wall: '牆',
      "door": "單扇平開門",
      "door-double": "雙扇平開門",
      "door-parent-child": "子母門",
      "sliding-door": "雙扇推拉門",
      "door-pocket": "牆內單拉門",
      "door-surface-sliding": "牆外單拉門",
      "door-folding": "折疊門",
      "window": "推拉窗",
      "window-fixed": "固定窗",
      "window-side-hung": "側開窗",
      "window-casement": "縱向滑撐外開窗",
      "window-awning": "橫向外開窗",
      split: '洞口',
      sofa: '沙發',
      bed: '床',
      chair: '椅子',
      bench: '長凳',
      'dining-table': '餐桌',
      'round-table': '圓桌',
      'low-table': '矮桌',
      desk: '書桌',
      'side-table': '邊几',
      console: '玄關檯',
      shelf: '置物架',
      cabinet: '櫃子',
      'clothes-rack': '衣架',
      'tv-board': '電視櫃',
      refrigerator: '冰箱',
      kitchen: '廚房檯面',
      toilet: '馬桶',
      bathtub: '浴缸',
      washbasin: '洗面台',
      'washing-machine': '洗衣機',
      'shoe-cabinet': '鞋櫃',
      stair: '樓梯',
      'sofa-B': '沙發 B',
      'chair-A': '椅子 A',
      'chair-B': '椅子 B',
      column: '柱子',
      beam: '梁',
      'floor-opening': '樓板洞口',
      'ceiling-opening': '上部挑空',
      'ceiling-drop': '下沉天花板',
      'column-square': '方柱',
      'independent-column': '獨立柱',
      'fridge-A': '冰箱 A',
      'simple-stair': '直樓梯',
      'stair-l': 'L形樓梯',
      'stair-u': 'U形樓梯',
      'stair-c': '三跑樓梯',
      'tv-board-A': '電視櫃 A',
      'tv-board-B': '電視櫃 B',
      area: '房間區域'
    },
    attributes: {
      name: '名稱',
      visible: '可見',
      x: 'X',
      y: 'Y',
      rotation: '角度',
      offset: '位置',
      catalogItemId: 'Catalog 項',
      modelId: '模型 ID',
      textureId: '貼圖 ID',
      materialId: '材質 ID',
      displayName: '顯示名稱',
      computedAreaM2: '面積 (m²)',
      computedAreaTsubo: '面積 (坪)'
    },
    properties: {
      type: "形式",
      hinge: "鉸鏈／移門側",
      swing: "開啟方向",
      registeredSize: "登錄尺寸",
      foldingPanels: "門扇數",
      handleStyle: "把手",
      finish: '飾面',
      beamDepth: '樑高',
      dropDepth: '下沉高度',
      openingWidth: "門洞寬",
      storageSide: "收納方向",
      mountSide: "安裝側",
      pocketSlotSide: "收納槽側",

      size: '尺寸',
      basicParams: '基礎參數',
      dimensionParams: '尺寸',
      roomName: '房間名',
      sizeVariant: '尺寸規格',
      selectedMaterial: '目前',
      searchMaterial: '依名稱篩選',
      noMaterialMatch: '沒有符合的材質',
      manufacturer: '品牌',
      width: '寬度',
      depth: '深度',
      height: '高度',
      length: '長度',
      thickness: '厚度',
      floorDistance: '離樓板距離',
      topHeight: '頂端高度',
      lighting: '照明',
      lightOnEvening: '傍晚以後點亮',
      floorElevation: '地面高低差',
      elevation: '離地高度',
      color: '顏色',
      material: '材質',
      texture: '紋理',
      texturePreview: '紋理預覽',
      rotation: '角度',
      offset: '位置',
      open: '開啟',
      flip_orizzontal: '反轉',
      position: '位置'
    },
    beamFinishes: {
      wood: '木紋（裝飾樑）',
      wallpaper: '壁紙（包樑）'
    },
    handleStyles: {
      lever: "執手",
      knob: "球形把手",
      pull: "拉手",
      bar: "長拉手",
      recessed: "凹槽拉手",
      none: "無"
    },
    fittingOptions: {
      panelCount: '{n} 扇',
      left: "左",
      right: "右",
      in: "向內",
      out: "向外",
      storageLeft: "向左收納",
      storageRight: "向右收納",
      mountIn: "內側",
      mountOut: "外側",
      slotIn: "內側",
      slotOut: "外側"
    },
    textures: {
      plain: '純色',
      default: '未設定',
      bricks: '磚牆',
      painted: '塗料',
      wood: '木地板',
      tile: '磁磚',
      tatami: '榻榻米',
      concrete: '混凝土',
      none: '無'
    },
    materials: {
      fabric: '織物',
      wood: '木材',
      metal: '金屬',
      glass: '玻璃',
      plastic: '塑膠'
    }
  },
  errors: {
    sessionExpired: '登入狀態已過期，請重新登入',
    requestFailed: '請求失敗',
    aiDesignNetworkError: '網絡錯誤，請檢查連接',
    aiDesignTimeout: '設計超時，請稍後重試',
    aiDesignServiceError: '服務暫時不可用',
    aiDesignValidationError: '輸入驗證失敗',
    aiDesignPartitionFailed: '無法根據當前外輪廓生成初始房間，請調整輪廓後重試',
    aiDesignOutlineShrunk: 'AI 返回的建築範圍小於原輪廓，已放棄本次結果',
    aiDesignParseError: '結果格式錯誤',
    aiDesign: {
      VALIDATION_ERROR: '輸入數據驗證失敗',
      NETWORK_ERROR: '網路連接失敗',
      TIMEOUT: '服務執行超時',
      REMOTE_SERVICE_ERROR: 'AI 服務返回失敗狀態',
      PARSE_ERROR: '下載包或 JSON 無法解析',
      PARTITION_FAILED: '當前牆圖無法形成完整 AI 輸入區域',
      OUTLINE_SHRUNK: '建築範圍發生變化',
      AI_RESULT_INVALID: 'AI 返回無效結構',
      AI_RESULT_STATS_MISMATCH: '後端統計與實際門窗不一致',
      AI_ELEMENT_GEOMETRY_CHANGED: '門窗階段越權修改了牆或房間',
      AI_SOURCE_SCENE_CHANGED: '戶型已變更，候選方案已過期',
      APPLY_FAILED: '應用 AI 方案失敗',
      UNKNOWN: '未知錯誤'
    }
  },
  reportStudio: {
    entry: '圖片製作',
    back: '返回編輯器',
    save: '儲存',
    saveSuccess: '報告素材已儲存',
    saveFailed: '報告素材儲存失敗，請稍後重試',
    saveStatusUnsaved: '未儲存',
    saveStatusSaved: '已儲存',
    canvasPlaceholder: '{type} 待實作',
    settingsPlaceholder: '設定欄（待實作）',
    assetRailPlaceholder: '素材欄（待實作）',
    types: {
      layout: '配置圖',
      floorPlan: '平面布置圖',
      render: '3D 渲染圖',
      elevation: '立面圖'
    },
    rail: {
      title: '已儲存素材',
      empty: '目前類型尚無已儲存素材',
      delete: '刪除',
      confirmForReport: '確認用於PDF/HTML報告',
      confirmedForReport: '已確認用於PDF/HTML',
      statusPreview: '預覽未確認',
      statusMissing: '缺失/待確認',
      slots: {
        layout: '配置圖',
        floorPlan: '樓層 {layer}',
        renderMain: '主視角',
        renderSubTop: '輔圖（上）',
        renderSubBottom: '輔圖（下）',
        elevationFront: '正面',
        elevationBack: '背面',
        elevationLeft: '左側',
        elevationRight: '右側'
      }
    },
    render: {
      renderType: '渲染類型',
      renderTypeScreenshot: '目前截圖',
      aiRender: 'AI 渲染',
      aiRenderPending: '介面待接入',
      cameraPresets: '視角預設',
      presets: {
        'oblique-front': '斜前方',
        aerial: '鳥瞰'
      },
      renderStyle: '渲染風格',
      renderStylePlaceholder: '即將支援',
      aspectRatio: '畫面比例',
      aspectRatioPlaceholder: '即將支援',
      saveCurrentView: '儲存目前視角',
      saveAsMain: '儲存為主圖',
      saveAsSubTop: '儲存為右上圖',
      saveAsSubBottom: '儲存為右下圖',
      resetCamera: '重設視角',
      captureFailed: '3D 截圖失敗'
    },
    elevation: {
      direction: '方向',
      directions: {
        front: '正面',
        back: '背面',
        left: '左側',
        right: '右側'
      },
      layoutMode: '排版模式',
      layoutModeSingle: '單張製作',
      layoutModeOverview: '四圖總覽',
      saveCurrentView: '儲存正交視角',
      saveDirection: '儲存{direction}',
      unsaved: '未儲存',
      backToOverview: '返回四圖總覽',
      resetCamera: '重設視角',
      captureFailed: '3D 截圖失敗',
      generateSingleViewPreview: '生成單個視角預覽'
    },
    confirm: {
      replaceTitle: '替換已確認圖片',
      replaceMessage: '該素材已確認用於 PDF/HTML 報告，是否用新圖片替換？',
      deleteTitle: '刪除報告素材',
      deleteMessage: '刪除後報告將缺失該素材，是否繼續？',
      noPreview: '請先在左側生成或選擇圖片',
      confirmButton: '確認'
    },
    capture: {
      deprecatedGuard: '此對話框已退出生產匯出路徑，請使用報告素材製作頁確認後再匯出。'
    },
    layout: {
      imageSource: '圖片來源',
      upload: '上傳圖片',
      pickExisting: '從已有圖選擇',
      pickEmpty: '暫無可選圖片',
      fitMode: '適配方式',
      fitWidth: '適應寬度',
      fitHeight: '適應高度',
      fitPage: '適應頁面',
      saveLayout: '儲存配置圖',
      noImageSelected: '請上傳或選擇一張圖片',
      canvasEmpty: '白頁預覽（未選擇圖片）',
      zoomIn: '放大',
      zoomOut: '縮小',
      uploadFailed: '圖片讀取失敗',
      uploadInvalidType: '請選擇圖片檔案'
    },
    floorPlan: {
      floorSwitch: '樓層切換',
      visibility: '顯隱開關',
      showTotalDimensions: '四周總尺寸',
      showSegmentDimensions: '頂底分段尺寸',
      showRoomNames: '房間名稱',
      showRoomAreas: '房間面積',
      showFurniture: '家具',
      showHoles: '門窗',
      dimensionActions: '尺寸操作',
      autoGenerate: '自動生成',
      addManual: '新增',
      cancelManualAdd: '取消新增',
      deleteSelected: '刪除選中',
      hideSelected: '隱藏選中',
      regenerateAll: '重新生成全部',
      resetOffsets: '重置 offset',
      roomLabelActions: '房間標籤',
      toggleRoomLabels: '標籤顯隱',
      resetRoomLabelPositions: '重置位置',
      saveCurrentFloor: '儲存目前樓層為報告素材',
      captureFailed: '平面圖截圖失敗',
      noChainSelected: '請先選中尺寸鏈',
      manualAddHint: '在畫布上依序點擊兩個點',
      manualAddInvalid: '目前僅支援水平/豎直尺寸',
      noDimensionBounds: '目前樓層沒有可生成尺寸的輪廓'
    }
  },
  reportExportConfirm: {
    title: {
      pdf: 'PDF 報告匯出確認',
      html: 'HTML 報告匯出確認'
    },
    generatePdf: '生成 PDF 報告',
    generateHtml: '生成 HTML 報告',
    optionalBadge: '可選',
    missingHint: '尚有 {count} 項必填素材缺失或待確認，請補全後再生成。',
    optionalMissingHint: '配置圖為可選項，缺失不影響報告生成。',
    openStudioHint: '點擊前往製作頁確認',
    statusConfirmed: '已確認',
    statusPreview: '待確認',
    statusMissing: '缺失/待確認'
  },
  // P06: 异步 AI 设计 UI 文案（供 P01–P05/P07 对齐；勿与 errors.aiDesign 混淆）
  aiDesign: {
    fields: {
      productType: 'ProductType（專案名）',
      totalArea: 'TotalArea（坪）',
      layers: 'Layers（樓層）',
      widthKen: 'WidthKen（間口）',
      unitPrice: '坪單價',
      unitPriceValue: '{count} 萬日圓/坪',
      totalAreaValue: '{count} 坪',
      budget: '預算',
      frontage: '間口',
      projectName: '專案名稱',
      algorithm: '演算法'
    },
    algorithms: {
      floorplan_diffusion: '擴散模型',
      floorplan_gpt_image_2: 'VLM',
      floorplan_gpt6: 'LLM Agent',
      building_element_diffusion: '門窗 Diffusion',
      building_element_rule: '門窗規則'
    },
    status: {
      queued: '排隊中',
      generating: '正在生成',
      completed: '已完成',
      failed: '生成失敗',
      waitedTime: '已等待 {seconds} 秒',
      canLeavePage: '可以離開本頁面'
    },
    actions: {
      abandonTask: '放棄任務',
      abandonConfirm: '確定放棄任務「{name}」嗎？放棄後結果將不再提示或套用。',
      viewNewPlan: '查看新方案',
      confirmReplace: '確認替換',
      retrySameParams: '按原參數重試'
    },
    waiting: {
      editLocked: '生成期間編輯已鎖定。任務會在背景繼續，您可以離開本頁面稍後再來查看。',
    },
    messages: {
      floorplanChanged: '目前戶型已變化',
      regenerateWindows: '請重新生成門窗',
      busy: '後台繁忙，請稍後再試。',
      taskRecordCorrupted: '任務記錄損壞',
      resultInvalid: '結果無效'
    },
    projectCard: {
      generating: '生成中',
      completed: '完成',
      failed: '失敗'
    },
    validation: {
      budget: '預算須為 500–3500 的整數（萬日圓）',
      input: '輸入無效',
      projectName: '請輸入專案名稱',
      frontage: '間口須為 2–5 間（步長 0.5）',
      layers: '樓層須為 1–3',
      algorithm: '所選演算法與目前設計類型不相符'
    }
  },
  drawingVectorize: {
    editor: {
      loadFailed: '無法載入標定後的圖紙，請稍後重試。',
      rescale: '比例尺',
      autosaveOn: '自動儲存',
      autosaveSaving: '儲存中…',
      autosaveSaved: '已儲存',
      autosaveFailed: '儲存失敗',
      furnitureArriving: '正在放置家具…',
      furnitureFailed: '家具辨識失敗。房間可以照常編輯',
      reupload: '重新生成',
      reuploadConfirm: '返回上傳頁面。'
    },
    rescale: {
      title: '修改比例尺',
      gridTitle: '小網格',
      gridHint: '牆體對齊所用的網格尺寸。',
      warning: '變更比例尺後，編輯器中的修改會被還原。',
      apply: '依此比例尺重新產生',
      confirm: '以此比例尺重新產生嗎？',
      done: '已修改比例尺'
    },
    upload: {
      title: '從圖紙匯入',
      handDrawnTitle: '上傳手繪平面圖',
      subtitle: '上傳平面圖，自動辨識牆體、門窗與房間。圖面上有尺寸時會自動設定比例尺；讀不到時點選一條已知長度的牆，輸入真實尺寸即可確定比例尺。',
      dropTitle: '圖紙上傳',
      dropMain: '請將平面圖拖放到此處',
      dropSub: '直接拖入圖片或文件，或點擊此區域選擇檔案',
      page: 'PDF 頁碼',
      pdfSelectTitle: '請選擇要辨識的頁面',
      pdfLoading: '正在載入 PDF 頁面…',
      pdfFailed: '無法預覽此 PDF，請改用頁碼指定。',
      pdfPageLabel: '第 {page} 頁',
      pdfPageCount: '共 {count} 頁',
      pdfTooManyPages: '僅顯示前 {max} 頁。',
      accepted: '支援 PNG / JPEG / TIFF / PDF，最大 5MB',
      tooLarge: '檔案超過 5MB',
      start: '開始辨識',
      cancel: '取消',
      stopWaiting: '停止等待',
      retry: '重試',
      detail: '詳細資訊',
      projectName: '專案名稱',
      apply: '進入編輯器',
      reupload: '重新上傳圖紙',
      backToEditor: '返回編輯器',
      sourceTitle: '上傳的圖紙',
      sourceOpen: '點擊查看大圖',
      sourceClose: '關閉',
      removeFile: '刪除已上傳的圖紙',
      regionHint: '拖動邊框可選擇辨識範圍。',
      regionReset: '恢復為整頁',
      reading: '正在讀取圖紙…',
      restoring: '正在載入上次的圖紙…',
      restoreFailed: '無法載入上次的圖紙，請重新上傳。',
      sourceNoPreview: 'PDF 無法在此直接預覽。'
    },
    progress: {
      uploading: '正在上傳圖紙',
      queued: '已排隊，等待辨識',
      recognizing: '正在辨識',
      backgroundNotice: '關閉後辨識仍會繼續。'
    },
    calibrate: {
      title: '比例尺標定',
      badgeCalibrated: '已標定',
      badgeUncalibrated: '未標定',
      assumedNotice: '請輸入正確的尺寸',
      pickPrompt: '在圖上點選一條已知長度的牆。',
      wholeWall: '軸線尺寸（芯到芯）',
      wholeWallUnavailable: '這條線反查不到原始牆，只能按單段測量。',
      currentLength: '目前長度',
      currentLengthValue: '約 {mm} mm（{px} px）',
      inputPlaceholder: '真實長度，單位毫米',
      submit: '標定',
      submitting: '計算中…',
      result: '{mmPerPx} mm/px ／ 參考：{reference}',
      badgeAuto: '自動設定',
      badgeSuggested: '待確認',
      autoTitle: '已根據圖面上的尺寸自動設定比例尺。',
      suggestedTitle: '已根據圖面上的尺寸推定比例尺，請確認後再確定。',
      reasons: {
        single_orientation: '只讀到了橫向或縱向其中一個方向的尺寸。',
        orientation_disagree: '橫向與縱向尺寸算出的比例尺不一致。',
        no_long_baseline: '沒有讀到貫穿整棟建築的長尺寸。',
        few_inliers: '相互吻合的尺寸條數不足。',
        low_agreement: '讀取到的尺寸之間差異較大。'
      },
      extentValue: '建築外形：約 {width} m × {height} m',
      acceptEstimate: '以此比例尺確定',
      pickPromptOverride: '如果不對，請在圖上點選一條已知長度的牆並輸入長度。',
      overridden: '已從依圖面尺寸自動設定的比例尺（{mmPerPx} mm/px）改為手動標定。',
      revertToEstimate: '恢復自動設定',
      referenceDimensions: '圖面尺寸'
    },
    quality: {
      title: '建議複核',
      adjustment: '辨識調整「{action}」：{count} 處',
      // 楼梯识别的调整记录。没有对应文案的动作码仍原样显示（见 WizardImportDrawingView）。
      actions: {
        area_relabelled_staircase: '房間裡畫有樓梯，已改為樓梯間',
        stair_synthesized_from_area: '在樓梯間內自動放置樓梯（未辨識到樓梯本體）',
        stair_form_inferred: '樓梯形式依房間形狀推斷',
        stair_direction_inferred: '樓梯上行方向為推斷',
        stair_facing_conflicts_footprint: '上行方向與占地矛盾，已調整朝向',
        stair_form_conflicts_footprint: '樓梯形式與占地矛盾，改依房間形狀推斷',
        stair_area_not_rectangular: '樓梯間不是矩形',
        stair_footprint_fallback_to_preset: '房間尺寸不合適，改用標準尺寸樓梯',
        stair_footprint_from_detection: '房間缺一角，樓梯占地改取辨識框（樓梯架在樓梯下收納上方）',
        stair_footprint_from_room_label: '辨識框太小，樓梯占地改取房間標註框',
        stair_clamped_to_min_footprint: '房間太小，改用最小尺寸樓梯',
        stair_overflows_area: '樓梯超出了房間範圍',
        stair_without_area: '樓梯不在任何房間內',
        stair_dropped_at_placement: '無法放置的樓梯',
        staircase_area_without_stair: '樓梯間過大或過小，未放置樓梯',
        staircase_label_ignored: '僅有 UP / DN 標註的大房間不按樓梯間處理',
        stair_opening_added: '在樓梯口那面牆上開了洞口（按樓梯朝向推定）',
        stair_opening_skipped_exterior: '樓梯口對著外牆，未開洞口（請確認樓梯朝向）',
        stair_opening_skipped_room: '樓梯口對著衛浴、收納或臥室，未開洞口（請確認樓梯朝向）',
        stair_opening_skipped_narrow: '樓梯口那面牆太短，開不出洞口',
        stair_orientation_from_start: '樓梯朝向按行走線起點（UP / DN 的起點）校正',
        stair_direction_from_neighbour: '樓梯朝向按樓梯口外面的房間推定',
        furniture_outside_building_dropped: '已移除遠離建築的家具（多為從同一頁的效果圖誤辨識）',
        floor_level_from_drawing: '根據圖面上的樓面標高（1FL-200、+300 等）設定了地板高低差',
        floor_level_assumed_from_name: '跳層（スキップフロア）、小上がり的地板高度以預設值設定（圖面上沒有標示高度，請在編輯器中確認）',
        floor_boundaries_split_rooms: '依地面高低差、扶手線（不是牆）劃分了房間',
        stair_room_carved: '樓梯與相鄰房間連成了一片，已把樓梯切成獨立的房間',
        column_dropped: '未作為獨立柱放置的候選（尺寸不符、在牆內或家具內）'
      },
      unmatchedRooms: '未能對應到面的房間：{names}',
      reviewRequired: '整體建議人工複核。',
      adviceOnly: '可在編輯器中修改。'
    },
    errors: {
      DRAWING_VECTORIZE_BUSY: '辨識服務忙碌，約 {seconds} 秒後重試。',
      DRAWING_VECTORIZE_FAILED: '辨識失敗，請稍後重試。',
      DRAWING_INPUT_UNSUPPORTED: '檔案格式不支援。請選擇 PNG / JPEG / TIFF / PDF，且不超過 5MB。',
      DRAWING_CALIBRATION_INVALID: '依這個長度無法標定。換一條牆或核對實際尺寸。',
      DRAWING_SCENE_REJECTED: '辨識結果無法載入編輯器。',
      TIMEOUT: '等待逾時，請重試。',
      NETWORK_ERROR: '網路無法連線。',
      REMOTE_SERVICE_ERROR: '服務回傳錯誤。',
      VALIDATION_ERROR: '請檢查輸入內容。',
      STORAGE_WRITE_FAILED: '儲存失敗。',
      NAME_REQUIRED: '請填寫專案名稱。',
      NOT_CALIBRATED: '比例尺尚未標定，請先輸入真實長度。',
      IMPORT_FAILED: '建立專案失敗。',
      DRAWING_JOB_SUBMIT_FAILED: '提交辨識工作失敗，請重試。',
      DRAWING_JOB_NOT_FOUND: '找不到這個辨識工作，請重新發起。',
      DRAWING_JOB_FAILED: '辨識工作執行失敗，請重試。',
      DRAWING_JOB_TIMEOUT: '等待辨識逾時。工作可能仍在背景執行，請稍後重試。',
      DRAWING_RESULT_NOT_READY: '辨識結果尚未就緒，請稍候。',
      UNKNOWN: '發生未知錯誤。'
    }
  },
  el: elementLocale.el
}
